export default __webpack_public_path__ + "static/Bloggingtop-458c472035fc84d22665e650fc3e1600.png";